import { useMutation } from '@tanstack/react-query';

import { AxiosError } from 'axios';

import {
  PostProjectsPrototypesPartialsByProjectIdAndPrototypeIdBody,
  TPrototypePartialDto,
  useAvApi,
} from '@app-velocity/av-api-v2';

export const useCreateBatchScenarioPartialsMutation = (
  workspaceId?: string,
  signal?: AbortSignal
) => {
  const { partials } = useAvApi();

  return useMutation<
    TPrototypePartialDto[] | undefined,
    AxiosError,
    {
      partialsBatch: PostProjectsPrototypesPartialsByProjectIdAndPrototypeIdBody[];
      prototypeId: string;
    }
  >({
    retry: 0,
    mutationKey: ['create-batch-scenario-partial-mutation-auth'],
    mutationFn: async ({
      partialsBatch,
      prototypeId,
    }: {
      partialsBatch: PostProjectsPrototypesPartialsByProjectIdAndPrototypeIdBody[];
      prototypeId: string;
    }) => {
      if (!workspaceId) return;

      const pageData = new FormData();

      for (const partial of partialsBatch) {
        pageData.append('index', partial.index);
        pageData.append('image', partial.image);
        pageData.append('name', partial.name);
        pageData.append('type', partial.type);
        pageData.append('data', partial.data);
        pageData.append('fileName', partial.fileName);
      }

      // TODO fix any - this is problem with API generator
      /* eslint-disable */
      const res =
        await partials.postProjectsPrototypesPartialsBatchByProjectIdAndPrototypeId(
          pageData as any,
          {
            projectId: workspaceId,
            prototypeId,
          },
          {} as any,
          {
            headers: {
              'Content-Type': 'multipart/form',
            },
            signal,
          }
        );
      /* eslint-disable */
      return res.data;
    },
  });
};
